import classNames from 'classnames/bind';
import styles from './NotePage.module.scss';
import MarkdownEditor from '~/Layouts/components/MarkdownEditor';
import { useState } from 'react';
import useMeta from '~/hooks/useMeta';

const cx = classNames.bind(styles);

function NotePage() {
    const [ setSavedContent] = useState("");

    useMeta({
      title: 'Viết định dạng - Blog Cá Nhân của Ngô Gia Quyến',
      description: 'Trang định dạng text.',
      keywords: 'blog, đăng bài viết, chia sẻ kinh nghiệm, viết blog, tư duy sáng tạo, kiến thức',
      author: 'Ngô Gia Quyến',
      url: 'https://ngogiaquyen.id.vn/note',
    });
  
  return (
    <div  className={cx('wrapper')}>
      <MarkdownEditor onSave={(content) => setSavedContent(content)} />
    </div>
  );
}

export default NotePage;
